import React from 'react';
import { supabase, isAuthConfigured } from './supabase';

const INDUSTRY_EMAILS = new Set(
  (process.env.REACT_APP_BINGEIQ_INDUSTRY_EMAILS || '')
    .split(',').map((email) => email.trim().toLowerCase()).filter(Boolean)
);
const INDUSTRY_ACCESS_STORAGE_KEY = 'bingeiq_industry_preview_access';

const storedIndustryAccess = () => {
  try {
    return window.sessionStorage.getItem(INDUSTRY_ACCESS_STORAGE_KEY) === 'true';
  } catch (_error) {
    return false;
  }
};

const storeIndustryAccess = (allowed) => {
  try {
    if (allowed) window.sessionStorage.setItem(INDUSTRY_ACCESS_STORAGE_KEY, 'true');
    else window.sessionStorage.removeItem(INDUSTRY_ACCESS_STORAGE_KEY);
  } catch (_error) {
    // Storage can be unavailable in privacy-restricted browsers; live auth remains authoritative.
  }
};

export const hasIndustryAccess = (user) => Boolean(
  user?.email && INDUSTRY_EMAILS.has(user.email.trim().toLowerCase())
);

export const useIndustrySession = () => {
  const [state, setState] = React.useState(() => ({ loading: true, user: null, allowed: storedIndustryAccess() }));

  React.useEffect(() => {
    if (!isAuthConfigured || !supabase) {
      setState({ loading: false, user: null, allowed: false });
      return undefined;
    }
    let alive = true;
    const apply = (session) => {
      if (!alive) return;
      const user = session?.user || null;
      const allowed = hasIndustryAccess(user);
      storeIndustryAccess(allowed);
      setState({ loading: false, user, allowed });
    };
    supabase.auth.getSession().then(({ data }) => apply(data.session));
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => apply(session));
    return () => { alive = false; sub?.subscription?.unsubscribe?.(); };
  }, []);

  return state;
};
